import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left-block {
    flex: 1;
    .work-step-content {
      .title-block {
        margin-bottom: 32px;
      }

      .ant-steps {
        max-width: fit-content;
        .ant-steps-item {
          padding-bottom: 20px;
          cursor: pointer;

          .ant-steps-item-title {
            font-size: 24px;
            color: ${theme.gray};
            margin-left: 40px;
            padding-right: 0;
          }

          .ant-steps-item-icon {
            margin-top: 6px;
            width: 23px;
            height: 23px;
            .ant-steps-icon-dot {
              top: 0 !important;
              left: 0 !important;
              background: #eae7e4;
            }
          }

          .ant-steps-item-tail {
            top: 18px;
            left: 0;
            padding: 0;
            &:after {
              width: 2px;
              margin-left: 11px;
              background: none;
              background-image: linear-gradient(#eae7e4 50%, rgba(255, 255, 255, 0) 0%);
              background-size: 2px 12px;
              background-repeat: repeat-y;
            }
          }
        }

        .ant-steps-item-active {
          .ant-steps-item-title {
            color: ${theme.primaryRed};
          }

          .ant-steps-item-icon .ant-steps-icon-dot {
            background: ${theme.white};
            border: 4px solid ${theme.primaryRed};
          }
        }
      }
    }
  }

  .right-block {
    margin-right: 40px;
    .title-block {
      display: none;
    }

    .circle {
      position: relative;
      width: 500px;
      height: 500px;
      border-radius: 100%;
      background-color: #ffe1c7;
      .image-block {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        transition: all 0.5s;
        height: 103%;
        opacity: 1;

        img {
          box-shadow: 0 0 5px 2px rgba(217 167 141 / 0.5) !important;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .left-block {
      .work-step-content {
        .ant-steps {
          max-width: 100%;
          .ant-steps-item {
            .ant-steps-item-title {
              margin-left: 5px;
              font-size: 18px;
            }
          }
        }
      }
    }

    .right-block {
      margin-right: 0;

      .circle {
        width: 360px;
        height: 360px;
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    flex-direction: column-reverse;

    .left-block {
      margin-top: 30px;
      .work-step-content {
        .title-block {
          display: none;
        }
        .ant-steps .ant-steps-item {
          padding-bottom: 0;
          .ant-steps-item-title {
            font-size: 16px;
          }
        }
      }
    }

    .right-block {
      .title-block {
        display: block;
        margin-bottom: 40px;
        text-align: center;
      }

      .circle {
        width: 315px;
        height: 315px;
      }
    }
  }
`
